import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';
import { BillingPaymentsPage } from './types';

export interface UseGetBillingPaymentsParams {
	month?: number;
	year?: number;
	page?: number;
	limit?: number;
}

export function useGetBillingPayments({ month, year, page = 1, limit = 10 }: UseGetBillingPaymentsParams = {}) {
	return useQuery<BillingPaymentsPage>({
		queryKey: ['billing-payments', month, year, page, limit],
		placeholderData: (previousData) => previousData,
		queryFn: async () => {
			try {
				const { data } = await api.get<BillingPaymentsPage>('/invoicing/payments', {
					params: { month, year, page, limit },
				});
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao buscar pagamentos.');
			}
		},
	});
}
